import Swal from 'sweetalert2';
import { Color } from '../../assets/color';
import * as actionTypes from "../action-types";
import { deleteAPI, getAPI, patchAPI, postAPI } from '../../utils/api-function';
import { put, call, takeLeading } from 'redux-saga/effects';
import {
    //* Admin
    get_admins, get_admin_by_id, create_admin, update_admin, delete_admin,

    //* Partner
    get_partner_by_adminId,

    //* Admin Report Wallet
    get_admin_report_wallets, create_admin_report_wallet, update_admin_report_wallet, delete_admin_report_wallet,

    //* Registration Number
    get_registration_numbers, create_registration_number, update_registration_number, delete_registration_number,

    //* Coupon
    get_coupons, create_coupon, update_coupon, delete_coupon,

    //* Report
    get_report_modules, get_reports, create_report, update_report, delete_report, get_generated_reports,

    //* Static Page
    create_update_static_page, get_about_us, get_privacy_policy, get_shipping_policy, get_refund_policy, get_terms_of_use,

    //* Video: Tutorials & Business
    get_tutorials_videos, get_business_videos, create_video, update_video, delete_video, change_video_status,

    //* Blogs
    get_blogs, get_blog_by_id, create_blog, update_blog, delete_blog,

    //* Partner Bank Detail
    get_partner_bank_details, get_active_partner_bank_detail, create_partner_bank_detail, update_partner_bank_detail, delete_partner_bank_detail, change_partner_bank_detail_status,

    //* Bug Tracker
    get_bug_reports, get_bug_report_by_id, create_bug_report, update_bug_report,
    update_bug_status, add_bug_comment, add_bug_resolution, add_bug_test_report,
    delete_bug_report, get_bug_stats, search_bug_reports,

    //* Site Settings
    get_site_settings, create_update_site_settings,

    //* Awards
    get_awards, create_award, update_award, delete_award, change_award_status,

    //* Media Coverage
    get_media_coverage, create_media_coverage, update_media_coverage, delete_media_coverage, change_media_coverage_status,

    //* Testimonial Videos
    get_testimonial_videos,

} from '../../utils/api-routes';

//! Admin
function* getAdmins() {
    try {
        const { data } = yield getAPI(get_admins);
        console.log("Get Admin Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ADMINS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_ADMINS, payload: [] });
        }

    } catch (error) {
        console.log("Get Admin Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_ADMINS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* getAdminById(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield getAPI(get_admin_by_id(payload));
        console.log("Get Admin By ID Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ADMIN_BY_ID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_ADMIN_BY_ID, payload: null });
        }

    } catch (error) {
        console.log("Get Admin By ID Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_ADMIN_BY_ID, payload: null });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to create this admin?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", })

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_admin, payload?.data);
            console.log("Create Admin Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Create Admin Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to update this admin?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", })

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_admin(payload?.id), payload?.data);
            console.log("Update Admin Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Admin Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", })
        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_admin(payload?.id));
            console.log("Delete Admin Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000, });
                yield put({ type: actionTypes.GET_ADMINS, payload: null });
            }
        }

    } catch (error) {
        console.log("Delete Admin Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//* Partner
function* getPartnerByAdminId(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield getAPI(get_partner_by_adminId(payload?.adminId));
        console.log("Get Partner By AdminId Saga Response :::", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PARTNER_BY_ADMINID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_PARTNER_BY_ADMINID, payload: null });
        }

    } catch (error) {
        console.error("Get Partner By AdminId Saga Error :::", error);
        Swal.fire({ icon: 'error', text: error?.response?.data?.message || "Something went wrong", timer: 10000 });
        yield put({ type: actionTypes.SET_PARTNER_BY_ADMINID, payload: null });
    }
};

//* Partner Bank Detail
function* getPartnerBankDetails(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield getAPI(get_partner_bank_details(payload));
        console.log("Partner Bank Details Saga Response :::", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PARTNER_BANK_DETAILS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_PARTNER_BANK_DETAILS, payload: [] });
        }

    } catch (error) {
        console.log("Get Partner Bank Details Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
        yield put({ type: actionTypes.SET_PARTNER_BANK_DETAILS, payload: [] });
    }
};

function* getActivePartnerBankDetail(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield getAPI(get_active_partner_bank_detail(payload));
        console.log("Active Partner Bank Detail Saga Response :::", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ACTIVE_PARTNER_BANK_DETAIL, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_ACTIVE_PARTNER_BANK_DETAIL, payload: null });
        }

    } catch (error) {
        console.log("Get Active Partner Bank Detail Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
        yield put({ type: actionTypes.SET_ACTIVE_PARTNER_BANK_DETAIL, payload: null });
    }
};

function* createPartnerBankDetail(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to create this partner bank detail?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_partner_bank_detail, payload?.data);
            console.log("Create Partner Bank Detail Saga Response :::", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_PARTNER_BANK_DETAILS, payload: {} });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }

    } catch (error) {
        console.log("Create Partner Bank Detail Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updatePartnerBankDetail(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this partner bank detail?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_partner_bank_detail(payload?.id), payload?.data);
            console.log("Update Partner Bank Detail Saga Response :::", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_PARTNER_BANK_DETAILS, payload: {} });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }

    } catch (error) {
        console.log("Update Partner Bank Detail Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deletePartnerBankDetail(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this partner bank detail?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_partner_bank_detail(payload?.id));
            console.log("Delete Partner Bank Detail Saga Response :::", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_PARTNER_BANK_DETAILS, payload: {} });
            }
        }

    } catch (error) {
        console.log("Delete Partner Bank Detail Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* changePartnerBankDetailStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to change status of this partner bank detail?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(change_partner_bank_detail_status(payload?.id));
            console.log("Change Partner Bank Detail Status Saga Response :::", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_PARTNER_BANK_DETAILS, payload: {} });
            }
        }

    } catch (error) {
        console.log("Change Partner Bank Detail Status Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Admin Report Wallet
function* getAdminReportWallets() {
    try {
        const { data } = yield getAPI(get_admin_report_wallets);
        console.log("Admin Report Wallets Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ADMIN_REPORT_WALLETS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_ADMIN_REPORT_WALLETS, payload: [] });
        }
    } catch (error) {
        console.log("Admin Report Wallets Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
        yield put({ type: actionTypes.SET_ADMIN_REPORT_WALLETS, payload: [] });
    }
};

function* createAdminReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to add token in admin wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_admin_report_wallet, payload?.data);
            console.log("Create Admin Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_ADMIN_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Create Admin Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateAdminReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this entry and token in admin wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_admin_report_wallet(payload?.id), payload?.data);
            console.log("Update Admin Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_ADMIN_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Update Admin Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteAdminReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this entry and token in admin wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_admin_report_wallet(payload?.id));
            console.log("Delete Admin Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_ADMIN_REPORT_WALLETS });
            }
        }
    } catch (error) {
        console.log("Delete Admin Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Registration Number
function* getRegistrationNumbers() {
    try {
        const { data } = yield getAPI(get_registration_numbers);
        console.log("Get Registration Number Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REGISTRATION_NUMBERS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_REGISTRATION_NUMBERS, payload: [] });
        }
    } catch (error) {
        console.log("Get Registration Numbers Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_REGISTRATION_NUMBERS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createRegistrationNumber(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to create this registration number?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_registration_number, payload?.data);
            console.log("Create Registration Number Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_REGISTRATION_NUMBERS, payload: null });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Create Registration Number Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateRegistrationNumber(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to update this registration number?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_registration_number(payload?.id), payload?.data);
            console.log("Update Registration Number Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_REGISTRATION_NUMBERS, payload: null });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Registration Number Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteRegistrationNumber(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete this registration number?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_registration_number(payload?.id), payload?.data);
            console.log("Delete Registration Number Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_REGISTRATION_NUMBERS });
            }
        }

    } catch (error) {
        console.log("Delete Registration Number Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Coupon
function* getCoupons() {
    try {
        const { data } = yield getAPI(get_coupons);
        console.log("Get Coupons Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_COUPONS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_COUPONS, payload: [] });
        }

    } catch (error) {
        console.log("Get Coupons Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_COUPONS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createCoupon(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to create this coupon?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_coupon, payload?.data);
            console.log("Create Coupon Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_COUPONS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create Coupon Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateCoupon(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to update this coupon?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_coupon(payload?.id), payload?.data);
            console.log("Update Coupon Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_COUPONS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Coupon Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteCoupon(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete this coupon?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_coupon(payload?.id));
            console.log("Delete Coupon Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_COUPONS });
            }
        }
    } catch (error) {
        console.log("Delete Coupon Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Video: Tutorials & Business
function* getVideos(action) {
    const { payload } = action;
    console.log("Payload ::: ", payload);

    try {
        const apiUrl = payload?.type === 'Business-Video' ? get_business_videos : payload?.type === 'Testimonial' ? get_testimonial_videos : get_tutorials_videos;
        const { data } = yield getAPI(apiUrl);
        console.log("Get Videos Saga Response ::: ", data);

        if (data?.status) {
            if (payload?.type === 'Business-Video') {
                yield put({ type: actionTypes.SET_BUSINESS_VIDEOS, payload: data.result });
            } else if (payload?.type === 'Testimonial') {
                yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: data.result });
            } else {
                yield put({ type: actionTypes.SET_TUTORIAL_VIDEOS, payload: data.result });
            }
        } else {
            if (payload?.type === 'Business-Video') {
                yield put({ type: actionTypes.SET_BUSINESS_VIDEOS, payload: [] });
            } else if (payload?.type === 'Testimonial') {
                yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: [] });
            } else {
                yield put({ type: actionTypes.SET_TUTORIAL_VIDEOS, payload: [] });
            }
        }
    } catch (error) {
        console.log("Get Videos Saga Error ::: ", error);
        if (payload?.type === 'Business-Video') {
            yield put({ type: actionTypes.SET_BUSINESS_VIDEOS, payload: [] });
        } else if (payload?.type === 'Testimonial') {
            yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: [] });
        } else {
            yield put({ type: actionTypes.SET_TUTORIAL_VIDEOS, payload: [] });
        }
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createVideo(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure?`, text: "You want to create this video?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_video, payload?.data);
            console.log("Create Video Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_VIDEOS, payload: { type: payload?.data?.type } });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Create Video Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateVideo(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure?`, text: "You want to update this video?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_video(payload?.id), payload?.data);
            console.log("Update Video Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_VIDEOS, payload: { type: payload?.data?.type } });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Video Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteVideo(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure?`, text: "You want to delete this video?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_video(payload?.id));
            console.log("Delete Video Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_VIDEOS, payload: { type: payload?.type } });
            }
        }

    } catch (error) {
        console.log("Delete Video Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* changeVideoStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure?`, text: "You want to change status of this video?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(change_video_status(payload?.id), payload?.data);
            console.log("Change Video Status Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_VIDEOS, payload: { type: payload?.data?.type } });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Change Video Status Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Blog
export function* getBlogs() {
    try {
        const { data } = yield getAPI(get_blogs);
        console.log("Get Blogs Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BLOGS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_BLOGS, payload: [] });
        }

    } catch (error) {
        console.log("Get Blogs Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_BLOGS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

export function* getBlogById(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield getAPI(get_blog_by_id(payload?.id));
        console.log("Get Blog By ID Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BLOG_BY_ID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_BLOG_BY_ID, payload: null });
        }

    } catch (error) {
        console.log("Get Blog By ID Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_BLOG_BY_ID, payload: null });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

export function* createBlog(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to create this blog?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_blog, payload?.data);
            console.log("Create Blog Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Create Blog Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

export function* updateBlog(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this blog?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_blog(payload?.id), payload?.data, true); // 'true' for multipart
            console.log("Update Blog Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Blog Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

export function* deleteBlog(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this blog?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_blog(payload?.id));
            console.log("Delete Blog Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_BLOGS });
            }
        }

    } catch (error) {
        console.log("Delete Blog Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};


//! Report
function* getReportModules() {
    try {
        const { data } = yield getAPI(get_report_modules);
        console.log("Get Report Modules Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REPORT_MODULES, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_REPORT_MODULES, payload: [] });
        }

    } catch (error) {
        console.log("Get Report Modules Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_REPORT_MODULES, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* getReports() {
    try {
        const { data } = yield getAPI(get_reports);
        console.log("Get Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REPORTS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_REPORTS, payload: [] });
        }

    } catch (error) {
        console.log("Get Reports Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_REPORTS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createReport(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to create this Report?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_report, payload?.data);
            console.log("Create Report Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_REPORTS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateReport(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to update this Report?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_report(payload?.id), payload?.data);
            console.log("Update Report Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_REPORTS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteReport(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete this Report?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_report(payload?.id));
            console.log("Delete Report Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_REPORTS });
            }
        }
    } catch (error) {
        console.log("Delete Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* getCustomersAll() {
    try {
        const { data } = yield getAPI(get_generated_reports + '?all=true');
        console.log("Get Customers All Saga Response ::: ", data);
        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMERS_ALL, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_CUSTOMERS_ALL, payload: [] });
        }
    } catch (error) {
        console.log(error);
        yield put({ type: actionTypes.SET_CUSTOMERS_ALL, payload: [] });
    }
}

function* getGeneratedReports() {
    try {
        const { data } = yield getAPI(get_generated_reports);
        console.log("Get Generated Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_GENERATED_REPORTS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_GENERATED_REPORTS, payload: [] });
        }

    } catch (error) {
        console.log("Get Generated Reports Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_GENERATED_REPORTS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};


//! Static Page
function* createUpdateStaticPage(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_update_static_page, payload);
        console.log(`Create Or Update Static Page :- ${payload?.type} Saga Response ::: `, data);

        if (data?.status) {
            Swal.fire({ icon: "success", title: 'Success', text: data?.message, showConfirmButton: false, timer: 2000, });

            switch (payload?.type) {
                case 'Terms-Of-Use':
                    yield put({ type: actionTypes.GET_TERMS_OF_USE, payload: { user_type: payload?.user_type } });
                    break;
                case 'Privacy-Policy':
                    yield put({ type: actionTypes.GET_PRIVACY_POLICY, payload: { user_type: payload?.user_type } });
                    break;
                case 'Refund-Policy':
                    yield put({ type: actionTypes.GET_REFUND_POLICY, payload: { user_type: payload?.user_type } });
                    break;
                case 'About-Us':
                    yield put({ type: actionTypes.GET_ABOUT_US, payload: { user_type: payload?.user_type } });
                    break;
                default:
                    break;
            }
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: error?.response?.data?.message, showConfirmButton: false, timer: 2000 });
        console.log("Create Or Update Static Page Saga Error ::: ", error);
    }
};

function* getTermsOfUse(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_terms_of_use(payload?.user_type));
        console.log("Get Terms Of Use Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_TERMS_OF_USE, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_TERMS_OF_USE, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Terms Of Use Saga Error ::: ", error);
    }
};

function* getPrivacyPolicy(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_privacy_policy(payload?.user_type));
        console.log("Get Privacy Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PRIVACY_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_PRIVACY_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Privacy Policy Saga Error ::: ", error);
    }
};

function* getShippingPolicy(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_shipping_policy(payload?.user_type));
        console.log("Get Shipping Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_SHIPPING_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_SHIPPING_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Shipping Policy Saga Error ::: ", error);
    }
};

function* getRefundPolicy(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_refund_policy(payload?.user_type));
        console.log("Get Refund Policy Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REFUND_POLICY, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_REFUND_POLICY, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Refund Policy Saga Error ::: ", error);
    }
};

function* getAboutUs(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_about_us(payload?.user_type));
        console.log("Get About Us Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_ABOUT_US, payload: data?.result?.description });
        } else {
            yield put({ type: actionTypes.SET_ABOUT_US, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get About Us Saga Error ::: ", error);
    }
};

//! ============ BUG TRACKER SAGAS ============

function* getBugReportsSaga(action) {
    try {
        const { payload } = action;
        const params = new URLSearchParams();
        if (payload?.status) params.append('status', payload.status);
        if (payload?.priority) params.append('priority', payload.priority);
        if (payload?.module) params.append('module', payload.module);
        if (payload?.search) params.append('search', payload.search);

        const { data } = yield getAPI(get_bug_reports(params.toString()));
        console.log("Get Bug Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BUG_REPORTS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_BUG_REPORTS, payload: [] });
        }
    } catch (error) {
        console.log("Get Bug Reports Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_BUG_REPORTS, payload: [] });
    }
};

function* getBugReportByIdSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield getAPI(get_bug_report_by_id(payload));
        console.log("Get Bug Report By ID Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BUG_REPORT_BY_ID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_BUG_REPORT_BY_ID, payload: null });
        }
    } catch (error) {
        console.log("Get Bug Report By ID Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_BUG_REPORT_BY_ID, payload: null });
    }
};

function* createBugReportSaga(action) {
    try {
        const { payload } = action;
        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to submit this bug report?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Submit" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_bug_report, payload?.data);
            console.log("Create Bug Report Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 5000 });
            }
        }
    } catch (error) {
        console.log("Create Bug Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to create bug report", showConfirmButton: false, timer: 5000 });
    }
};

function* updateBugReportSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield patchAPI(update_bug_report(payload?.id), payload?.data);
        console.log("Update Bug Report Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
            if (payload?.onComplete) yield call(payload.onComplete);
        } else {
            Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 5000 });
        }
    } catch (error) {
        console.log("Update Bug Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to update", showConfirmButton: false, timer: 5000 });
    }
};

function* updateBugStatusSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield patchAPI(update_bug_status(payload?.id), payload?.data);
        console.log("Update Bug Status Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
            if (payload?.onComplete) yield call(payload.onComplete);
        }
    } catch (error) {
        console.log("Update Bug Status Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to update status", showConfirmButton: false, timer: 5000 });
    }
};

function* addBugCommentSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield postAPI(add_bug_comment(payload?.id), payload?.data);
        console.log("Add Bug Comment Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: "Comment added.", showConfirmButton: false, timer: 1500 });
            if (payload?.onComplete) yield call(payload.onComplete);
        }
    } catch (error) {
        console.log("Add Bug Comment Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to add comment", showConfirmButton: false, timer: 5000 });
    }
};

function* addBugResolutionSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield patchAPI(add_bug_resolution(payload?.id), payload?.data);
        console.log("Add Bug Resolution Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: "Resolution added.", showConfirmButton: false, timer: 1500 });
            if (payload?.onComplete) yield call(payload.onComplete);
        }
    } catch (error) {
        console.log("Add Bug Resolution Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to add resolution", showConfirmButton: false, timer: 5000 });
    }
};

function* addBugTestReportSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield patchAPI(add_bug_test_report(payload?.id), payload?.data);
        console.log("Add Bug Test Report Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: "Test report added.", showConfirmButton: false, timer: 1500 });
            if (payload?.onComplete) yield call(payload.onComplete);
        }
    } catch (error) {
        console.log("Add Bug Test Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to add test report", showConfirmButton: false, timer: 5000 });
    }
};

function* deleteBugReportSaga(action) {
    try {
        const { payload } = action;
        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this bug report?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_bug_report(payload?.id));
            console.log("Delete Bug Report Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_BUG_REPORTS });
            }
        }
    } catch (error) {
        console.log("Delete Bug Report Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message || "Failed to delete", showConfirmButton: false, timer: 5000 });
    }
};

function* getBugStatsSaga() {
    try {
        const { data } = yield getAPI(get_bug_stats);
        console.log("Get Bug Stats Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BUG_STATS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_BUG_STATS, payload: null });
        }
    } catch (error) {
        console.log("Get Bug Stats Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_BUG_STATS, payload: null });
    }
};

function* searchBugReportsSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield getAPI(search_bug_reports(payload));
        console.log("Search Bug Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_SEARCH_BUG_REPORTS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_SEARCH_BUG_REPORTS, payload: [] });
        }
    } catch (error) {
        console.log("Search Bug Reports Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_SEARCH_BUG_REPORTS, payload: [] });
    }
};

//! Site Settings
function* getSiteSettingsSaga() {
    try {
        const { data } = yield getAPI(get_site_settings);
        console.log("Get Site Settings Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_SITE_SETTINGS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_SITE_SETTINGS, payload: null });
        }
    } catch (error) {
        console.log("Get Site Settings Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_SITE_SETTINGS, payload: null });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createUpdateSiteSettingsSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update site settings?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_update_site_settings, payload?.data);
            console.log("Create/Update Site Settings Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_SITE_SETTINGS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create/Update Site Settings Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Awards
function* getAwardsSaga() {
    try {
        const { data } = yield getAPI(get_awards);
        console.log("Get Awards Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_AWARDS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_AWARDS, payload: [] });
        }
    } catch (error) {
        console.log("Get Awards Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_AWARDS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createAwardSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to create this award?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_award, payload?.data);
            console.log("Create Award Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_AWARDS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create Award Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateAwardSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this award?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_award(payload?.id), payload?.data);
            console.log("Update Award Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_AWARDS });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Update Award Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteAwardSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this award?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_award(payload?.id));
            console.log("Delete Award Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_AWARDS });
            }
        }
    } catch (error) {
        console.log("Delete Award Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* changeAwardStatusSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to change status of this award?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(change_award_status(payload?.id));
            console.log("Change Award Status Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_AWARDS });
            }
        }
    } catch (error) {
        console.log("Change Award Status Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Media Coverage
function* getMediaCoverageSaga() {
    try {
        const { data } = yield getAPI(get_media_coverage);
        console.log("Get Media Coverage Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_MEDIA_COVERAGE, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_MEDIA_COVERAGE, payload: [] });
        }
    } catch (error) {
        console.log("Get Media Coverage Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_MEDIA_COVERAGE, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createMediaCoverageSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to create this media coverage?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_media_coverage, payload?.data);
            console.log("Create Media Coverage Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_MEDIA_COVERAGE });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create Media Coverage Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateMediaCoverageSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this media coverage?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_media_coverage(payload?.id), payload?.data);
            console.log("Update Media Coverage Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_MEDIA_COVERAGE });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Update Media Coverage Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteMediaCoverageSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this media coverage?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_media_coverage(payload?.id));
            console.log("Delete Media Coverage Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_MEDIA_COVERAGE });
            }
        }
    } catch (error) {
        console.log("Delete Media Coverage Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* changeMediaCoverageStatusSaga(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to change status of this media coverage?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(change_media_coverage_status(payload?.id));
            console.log("Change Media Coverage Status Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_MEDIA_COVERAGE });
            }
        }
    } catch (error) {
        console.log("Change Media Coverage Status Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//! Testimonial Videos
function* getTestimonialVideosSaga() {
    try {
        const { data } = yield getAPI(get_testimonial_videos);
        console.log("Get Testimonial Videos Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: [] });
        }
    } catch (error) {
        console.log("Get Testimonial Videos Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

export default function* superadminSaga() {
    //! Admin
    yield takeLeading(actionTypes.GET_ADMINS, getAdmins);
    yield takeLeading(actionTypes.GET_ADMIN_BY_ID, getAdminById);
    yield takeLeading(actionTypes.CREATE_ADMIN, createAdmin);
    yield takeLeading(actionTypes.UPDATE_ADMIN, updateAdmin);
    yield takeLeading(actionTypes.DELETE_ADMIN, deleteAdmin);

    //* Partner
    yield takeLeading(actionTypes.GET_PARTNER_BY_ADMINID, getPartnerByAdminId);

    //* Partner Bank Detail
    yield takeLeading(actionTypes.GET_PARTNER_BANK_DETAILS, getPartnerBankDetails);
    yield takeLeading(actionTypes.GET_ACTIVE_PARTNER_BANK_DETAIL, getActivePartnerBankDetail);
    yield takeLeading(actionTypes.CREATE_PARTNER_BANK_DETAIL, createPartnerBankDetail);
    yield takeLeading(actionTypes.UPDATE_PARTNER_BANK_DETAIL, updatePartnerBankDetail);
    yield takeLeading(actionTypes.DELETE_PARTNER_BANK_DETAIL, deletePartnerBankDetail);
    yield takeLeading(actionTypes.CHANGE_PARTNER_BANK_DETAIL_STATUS, changePartnerBankDetailStatus);

    //! Admin Report Wallet
    yield takeLeading(actionTypes.GET_ADMIN_REPORT_WALLETS, getAdminReportWallets);
    yield takeLeading(actionTypes.CREATE_ADMIN_REPORT_WALLET, createAdminReportWallet);
    yield takeLeading(actionTypes.UPDATE_ADMIN_REPORT_WALLET, updateAdminReportWallet);
    yield takeLeading(actionTypes.DELETE_ADMIN_REPORT_WALLET, deleteAdminReportWallet);

    //! Registration Number
    yield takeLeading(actionTypes.GET_REGISTRATION_NUMBERS, getRegistrationNumbers);
    yield takeLeading(actionTypes.CREATE_REGISTRATION_NUMBER, createRegistrationNumber);
    yield takeLeading(actionTypes.UPDATE_REGISTRATION_NUMBER, updateRegistrationNumber);
    yield takeLeading(actionTypes.DELETE_REGISTRATION_NUMBER, deleteRegistrationNumber);

    //! Coupon
    yield takeLeading(actionTypes.GET_COUPONS, getCoupons);
    yield takeLeading(actionTypes.CREATE_COUPON, createCoupon);
    yield takeLeading(actionTypes.UPDATE_COUPON, updateCoupon);
    yield takeLeading(actionTypes.DELETE_COUPON, deleteCoupon);

    //! Video: Tutorials & Business
    yield takeLeading(actionTypes.GET_VIDEOS, getVideos);
    yield takeLeading(actionTypes.CREATE_VIDEO, createVideo);
    yield takeLeading(actionTypes.UPDATE_VIDEO, updateVideo);
    yield takeLeading(actionTypes.DELETE_VIDEO, deleteVideo);
    yield takeLeading(actionTypes.CHANGE_VIDEO_STATUS, changeVideoStatus);

    //! Blog
    yield takeLeading(actionTypes.GET_BLOGS, getBlogs);
    yield takeLeading(actionTypes.GET_BLOG_BY_ID, getBlogById);
    yield takeLeading(actionTypes.CREATE_BLOG, createBlog);
    yield takeLeading(actionTypes.UPDATE_BLOG, updateBlog);
    yield takeLeading(actionTypes.DELETE_BLOG, deleteBlog);

    //! Report
    yield takeLeading(actionTypes.GET_REPORT_MODULES, getReportModules);
    yield takeLeading(actionTypes.GET_REPORTS, getReports);
    yield takeLeading(actionTypes.CREATE_REPORT, createReport);
    yield takeLeading(actionTypes.UPDATE_REPORT, updateReport);
    yield takeLeading(actionTypes.DELETE_REPORT, deleteReport);
    yield takeLeading(actionTypes.GET_GENERATED_REPORTS, getGeneratedReports);
    yield takeLeading(actionTypes.GET_CUSTOMERS_ALL, getCustomersAll);

    //! Static Page
    yield takeLeading(actionTypes.CREATE_UPDATE_STATIC_PAGE, createUpdateStaticPage);
    yield takeLeading(actionTypes.GET_TERMS_OF_USE, getTermsOfUse);
    yield takeLeading(actionTypes.GET_PRIVACY_POLICY, getPrivacyPolicy);
    yield takeLeading(actionTypes.GET_SHIPPING_POLICY, getShippingPolicy);
    yield takeLeading(actionTypes.GET_REFUND_POLICY, getRefundPolicy);
    yield takeLeading(actionTypes.GET_ABOUT_US, getAboutUs);

    //! Bug Tracker
    yield takeLeading(actionTypes.GET_BUG_REPORTS, getBugReportsSaga);
    yield takeLeading(actionTypes.GET_BUG_REPORT_BY_ID, getBugReportByIdSaga);
    yield takeLeading(actionTypes.CREATE_BUG_REPORT, createBugReportSaga);
    yield takeLeading(actionTypes.UPDATE_BUG_REPORT, updateBugReportSaga);
    yield takeLeading(actionTypes.UPDATE_BUG_STATUS, updateBugStatusSaga);
    yield takeLeading(actionTypes.ADD_BUG_COMMENT, addBugCommentSaga);
    yield takeLeading(actionTypes.ADD_BUG_RESOLUTION, addBugResolutionSaga);
    yield takeLeading(actionTypes.ADD_BUG_TEST_REPORT, addBugTestReportSaga);
    yield takeLeading(actionTypes.DELETE_BUG_REPORT, deleteBugReportSaga);
    yield takeLeading(actionTypes.GET_BUG_STATS, getBugStatsSaga);
    yield takeLeading(actionTypes.SEARCH_BUG_REPORTS, searchBugReportsSaga);

    //! Site Settings
    yield takeLeading(actionTypes.GET_SITE_SETTINGS, getSiteSettingsSaga);
    yield takeLeading(actionTypes.CREATE_UPDATE_SITE_SETTINGS, createUpdateSiteSettingsSaga);

    //! Awards
    yield takeLeading(actionTypes.GET_AWARDS, getAwardsSaga);
    yield takeLeading(actionTypes.CREATE_AWARD, createAwardSaga);
    yield takeLeading(actionTypes.UPDATE_AWARD, updateAwardSaga);
    yield takeLeading(actionTypes.DELETE_AWARD, deleteAwardSaga);
    yield takeLeading(actionTypes.CHANGE_AWARD_STATUS, changeAwardStatusSaga);

    //! Media Coverage
    yield takeLeading(actionTypes.GET_MEDIA_COVERAGE, getMediaCoverageSaga);
    yield takeLeading(actionTypes.CREATE_MEDIA_COVERAGE, createMediaCoverageSaga);
    yield takeLeading(actionTypes.UPDATE_MEDIA_COVERAGE, updateMediaCoverageSaga);
    yield takeLeading(actionTypes.DELETE_MEDIA_COVERAGE, deleteMediaCoverageSaga);
    yield takeLeading(actionTypes.CHANGE_MEDIA_COVERAGE_STATUS, changeMediaCoverageStatusSaga);

    //! Testimonial Videos
    yield takeLeading(actionTypes.GET_TESTIMONIAL_VIDEOS, getTestimonialVideosSaga);
};